// extracted by mini-css-extract-plugin
export var analysisPage = "color-analysis-module--analysis-page--D2Loh";
export var answerButton = "color-analysis-module--answer-button--61iQz";
export var answerSelected = "color-analysis-module--answer-selected--PdOAn";
export var answersGrid = "color-analysis-module--answers-grid--P4dsN";
export var avoidList = "color-analysis-module--avoid-list--UMpiA";
export var backButton = "color-analysis-module--back-button--djcrI";
export var confidence = "color-analysis-module--confidence--iI+hR";
export var disclaimer = "color-analysis-module--disclaimer--aXFyf";
export var eyebrow = "color-analysis-module--eyebrow--Tfvr5";
export var intro = "color-analysis-module--intro--h3zqo";
export var introArt = "color-analysis-module--intro-art--OA3OA";
export var introBadge = "color-analysis-module--intro-badge--cAGWQ";
export var introBadges = "color-analysis-module--intro-badges--KFX9D";
export var introCopy = "color-analysis-module--intro-copy--w32gf";
export var introLead = "color-analysis-module--intro-lead--n8QoP";
export var introTitle = "color-analysis-module--intro-title--4gDGk";
export var pageShell = "color-analysis-module--page-shell--BHhqj";
export var primaryAction = "color-analysis-module--primary-action--Qlksw";
export var privacyNote = "color-analysis-module--privacy-note--TG7Ug";
export var progressFill = "color-analysis-module--progress-fill--FwiYM";
export var progressMeta = "color-analysis-module--progress-meta--HN5k5";
export var progressTrack = "color-analysis-module--progress-track--156XC";
export var questionCard = "color-analysis-module--question-card--hywiK";
export var questionHint = "color-analysis-module--question-hint--IONtk";
export var questionNumber = "color-analysis-module--question-number--u3yMz";
export var questionTitle = "color-analysis-module--question-title--BPbGC";
export var questionVisual = "color-analysis-module--question-visual--ODFBo";
export var quizNav = "color-analysis-module--quiz-nav--WQxXs";
export var quizSection = "color-analysis-module--quiz-section--bQZiN";
export var restartButton = "color-analysis-module--restart-button---w0Y+";
export var resultActions = "color-analysis-module--result-actions--4Ae3N";
export var resultEyebrow = "color-analysis-module--result-eyebrow--5jHv8";
export var resultGrid = "color-analysis-module--result-grid--MSuGS";
export var resultHeader = "color-analysis-module--result-header--4EUwp";
export var resultList = "color-analysis-module--result-list--QPNvu";
export var resultLists = "color-analysis-module--result-lists--jE8nd";
export var resultPalette = "color-analysis-module--result-palette--iPgoP";
export var resultPortrait = "color-analysis-module--result-portrait--0dHcN";
export var resultSection = "color-analysis-module--result-section--90JrD";
export var resultSummary = "color-analysis-module--result-summary--Yf5G7";
export var resultTitle = "color-analysis-module--result-title--PjlOE";
export var scoreBar = "color-analysis-module--score-bar--FfVC5";
export var scoreDetails = "color-analysis-module--score-details--B0JRT";
export var scoreRow = "color-analysis-module--score-row--5hfzM";
export var secondaryAction = "color-analysis-module--secondary-action--f5CxU";
export var swatch = "color-analysis-module--swatch--4vWpp";